import React, { memo, useState, useEffect } from 'react';
import { Grid, Card } from '@material-ui/core';
import logo from 'components/Logo/logo-dermpro.svg';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Link } from 'react-router-dom';


const useStyles = makeStyles(() => ({
  textHyphenation: {
    hyphens: 'auto',
  },
  imgContainer: {
    position: 'relative',
    paddingTop: '100%',
    width: '80%',
    overflow: 'hidden',
    margin: '12px auto',
  },
  img: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'scale-down',
  }
}));

const FulfillmentBrands = ({results, debouncedSearchBrand}) => {
  const [searchResult, setSearchResult] = useState(results);
  const classes = useStyles();

  useEffect(() => {
    if (debouncedSearchBrand) {
      setSearchResult(results.filter((brand) =>
        brand.value.toLowerCase().includes(debouncedSearchBrand)
      ));
    } else {
      setSearchResult(results);
    }
  }, [debouncedSearchBrand, results]);

  return (
    <Grid container spacing={4}>
      {searchResult && searchResult.map((brand, idx) => {
        if (brand.option_id) {
          return (
            <Grid item md={2} sm={4} xs={6} key={idx}>
              <Link to={`/direct-fulfillment/${brand.option_id}`}>
                <Card elevation={25} className={clsx('text-center min-h-200')}>
                  <div className={classes.imgContainer}>
                    <img
                      src={brand.image !== '' ? `${brand.image}` : logo}
                      alt={brand.value}
                      className={classes.img}
                      onError={(e) => {
                        (e.target as HTMLImageElement).onerror = null;
                        (e.target as HTMLImageElement).src = logo;
                      }}
                    />
                  </div>
                  <p className={clsx('text-brand font-bold p-2 text-center min-h-60', classes.textHyphenation)}>{brand.value}</p>
                </Card>
              </Link>
            </Grid>
          );
        }

        return null;
      })}
    </Grid>

  );
};

function brandsPropsAreEqual(prevProp, nextProp) {
  return prevProp.results.length === nextProp.results.length
    && prevProp.debouncedSearchBrand === nextProp.debouncedSearchBrand;
}

export default memo(FulfillmentBrands, brandsPropsAreEqual);
